import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FavoriteLocationIcon } from '../../common/icons/favoriteLocationIcon';

export const FavoriteLocationButton = memo(({ isFavoriteLocation, onClick }) => {
    return (
        <Container onClick={onClick}>
            <FavoriteLocationIcon isFavoriteLocation={isFavoriteLocation} />
        </Container>
    );
});

FavoriteLocationButton.displayName = 'FavoriteLocationButton';

FavoriteLocationButton.propTypes = {
    isFavoriteLocation: PropTypes.bool,
    onClick: PropTypes.func.isRequired
};

const Container = styled.div`
    padding-left: 10px;
    cursor: pointer;
    height: 100%;
    display: flex;
    align-items: center;
    padding-right: 10px;
    &:hover {
        background-color: rgba(47,111,140,0.05)
    }
`;
